<template>
    <ui-dropdown menu-class="w-[36em]" :trigger-class="triggerClass" :arrow="true"
                 @closed="(e) => $emit('closed',e)" @opened="(e) => $emit('opened',e)">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>
        <template #menu="{ close }">
            <div class="p-4 pt-3">
                <div>
                    <div class="text-center font-medium text-gray-600 mb-2 gap-4 pl-3">Risk Matrix</div>
                    <table class="w-full text-xs font-medium text-gray-400">
                        <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td class="h-12 w-20 whitespace-nowrap text-center">V. Unlikely</td>
                            <td class="w-20 whitespace-nowrap text-center">Unlikely</td>
                            <td class="w-20 whitespace-nowrap text-center">Possible</td>
                            <td class="w-20 whitespace-nowrap text-center">Likely</td>
                            <td class="w-20 whitespace-nowrap text-center">V. Likely</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td colspan="5" class="bg-gray-50 text-center border-gray-200 border p-0.5 h-6">Likelihood
                                of Harm
                            </td>
                        </tr>
                        <tr>
                            <td class="h-12 pr-2">Negligible</td>
                            <td rowspan="5" class="bg-gray-50 text-center border-gray-200 border p-0.5 w-6 pt-16">
                                <div class="-rotate-90 whitespace-nowrap w-6 origin-center">Severity of Harm</div>
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(1,1)" :style="'background: '+getColor(1)">1
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(1,2)" :style="'background: '+getColor(2)">2
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(1,3)" :style="'background: '+getColor(3)">3
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(1,4)" :style="'background: '+getColor(4)">4
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(1,5)" :style="'background: '+getColor(5)">5
                            </td>
                        </tr>
                        <tr>
                            <td class="h-12 pr-2">Minor</td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(2,1)" :style="'background: '+getColor(2)">2
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(2,2)" :style="'background: '+getColor(4)">4
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(2,3)" :style="'background: '+getColor(6)">6
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(2,4)" :style="'background: '+getColor(8)">8
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(2,5)" :style="'background: '+getColor(10)">10
                            </td>
                        </tr>
                        <tr>
                            <td class="h-12 pr-2">Moderate</td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(3,1)" :style="'background: '+getColor(3)">3
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(3,2)" :style="'background: '+getColor(6)">6
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(3,3)" :style="'background: '+getColor(9)">9
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(3,4)" :style="'background: '+getColor(12)">12
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(3,5)" :style="'background: '+getColor(15)">15
                            </td>
                        </tr>
                        <tr>
                            <td class="h-12 pr-2">Major</td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(4,1)" :style="'background: '+getColor(4)">4
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(4,2)" :style="'background: '+getColor(8)">8
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(4,3)" :style="'background: '+getColor(12)">12
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(4,4)" :style="'background: '+getColor(16)">16
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(4,5)" :style="'background: '+getColor(20)">20
                            </td>
                        </tr>
                        <tr>
                            <td class="h-12 pr-2">Extreme</td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(5,1)" :style="'background: '+getColor(5)">5
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(5,2)" :style="'background: '+getColor(10)">10
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(5,3)" :style="'background: '+getColor(15)">15
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(5,4)" :style="'background: '+getColor(20)">20
                            </td>
                            <td class="text-center hover:border-blue-600 hover:border-2 text-white text-lg"
                                @click="select(5,5)" :style="'background: '+getColor(25)">25
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import UiDropdown from "../../ui/UiDropdown.vue";
import {RAMS} from '@models'

export default {
    components: {UiDropdown},
    props: {
        rams: Object,
        item: Object,
        triggerClass: '',
        readonly: false
    },
    data() {
        return {}
    },
    methods: {
        getColor(num) {
            return RAMS.getColor(num);
        },
        update(close = () => {
        }) {
            this.$emit('updated')
            close()
        },
        scope(dropdownScope) {
            let that = this
            return {
                ...dropdownScope,
            }
        },
        select(s, l) {
            this.item.severityOfHarm = s;
            this.item.likelihoodOfHarm = l;
            this.rams.update();
        }
    },
    mounted() {
    }
}
</script>
